/**
 * @file Defines the {@link DESKTOP_EVENTS} constant
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /**
  * @type {string[]}
  * @constant
  * @default
  */
 const DESKTOP_EVENTS = [

    'mousedown',
    'mouseup',
    'mouseover',
    'mouseleave'

 ]

 export { DESKTOP_EVENTS }